export class Typologic {
  id?: number;
  description: string;
  children?: Typologic[];
  type: string;
}
